import { Injectable } from '@angular/core';
import { Observable, forkJoin, of, switchMap } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AgentService } from './agent.service';
import { SessionService } from '../session.service';

@Injectable({
  providedIn: 'root'
})
export class AgentResolver {
  constructor(private agent: AgentService, private session: SessionService) {
  }

  resolve(): Observable<any> {
    return this.agent.getAgent();
  }
}
